import { IconBase, type IconProps } from './iconBase';

import type { JSX } from 'react';

export const AuditoryRight = ({ type, ...rest }: IconProps): JSX.Element => (
  <IconBase viewBox='0 0 25 24' {...rest}>
    {type === 'stroke' ? (
      <>
        <circle
          cx='4'
          cy='4'
          r='3.25'
          transform='matrix(-1 0 0 1 22.0605 8)'
          stroke='currentColor'
          strokeWidth='1.5'
        />
        <path
          d='M7.586 2.275a.94.94 0 0 0-1.326 0A13.7 13.7 0 0 0 2.232 12c0 3.798 1.54 7.237 4.028 9.725A.938.938 0 1 0 7.586 20.4 11.84 11.84 0 0 1 4.107 12a11.84 11.84 0 0 1 3.48-8.4.94.94 0 0 0 0-1.325'
          fill='currentColor'
        />
        <path
          d='M10.46 6.475a.938.938 0 0 1 1.326 1.326 5.92 5.92 0 0 0-1.74 4.2c0 1.64.664 3.124 1.74 4.2a.938.938 0 1 1-1.326 1.325 7.8 7.8 0 0 1-2.29-5.525c0-2.158.877-4.113 2.29-5.526'
          fill='currentColor'
        />
      </>
    ) : (
      <>
        <circle
          cx='4'
          cy='4'
          r='4'
          transform='matrix(-1 0 0 1 22.0605 8)'
          fill='currentColor'
        />
        <path
          d='M7.586 2.275a.94.94 0 0 0-1.326 0A13.7 13.7 0 0 0 2.232 12c0 3.798 1.54 7.237 4.028 9.725A.938.938 0 1 0 7.586 20.4 11.84 11.84 0 0 1 4.107 12a11.84 11.84 0 0 1 3.48-8.4.94.94 0 0 0 0-1.325'
          fill='currentColor'
        />
        <path
          d='M10.46 6.475a.938.938 0 0 1 1.326 1.326 5.92 5.92 0 0 0-1.74 4.2c0 1.64.664 3.124 1.74 4.2a.938.938 0 1 1-1.326 1.325 7.8 7.8 0 0 1-2.29-5.525c0-2.158.877-4.113 2.29-5.526'
          fill='currentColor'
        />
      </>
    )}
  </IconBase>
);
